export default __webpack_public_path__ + "3cd56290bd6bb9a3dcb916bc75d950ef.png";